<span class="d-inline-block" [attr.data-automation]="'natural-language-editor-single-' + phraseId()">
  <ng-select
    [items]="options()"
    [(ngModel)]="entity"
    class="expression-keyword__dropdown"
    [clearable]="false"
    [searchable]="false"
    bindLabel="label"
    bindValue="value"
    (ngModelChange)="onUpdate($event)"
    data-automation="natural-language-editor-single-dropdown"
  ></ng-select>
</span>
